import { render } from "./PostsCard.vue?vue&type=template&id=60048c5d&scoped=true"
import script from "./PostsCard.vue?vue&type=script&lang=js"
export * from "./PostsCard.vue?vue&type=script&lang=js"

import "./PostsCard.vue?vue&type=style&index=0&id=60048c5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60048c5d"]])

export default __exports__